
/**
 * 계정 상태
 */
export type GetAllUsers200ContentItemStatus = typeof GetAllUsers200ContentItemStatus[keyof typeof GetAllUsers200ContentItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAllUsers200ContentItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
} as const;
